export enum MessageBoxResult {
    None = 0,
    Ok = 1,
    Cancel = 2,
    Abort = 3,
    Yes = 4,
    No = 5
}